import Copy from './copy'
import Debounce from './debounce'
import NoPermission from './no-permission'
import Permission from './permission'
import EscClose from './esc-close'
// 自定义指令
const directives = {
  Copy,
  Debounce,
  NoPermission,
  Permission,
  EscClose
}

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  },
}